<script setup>
import { inject, ref } from 'vue'

const emitter = inject('emitter')

const toast = ref({
    type: 'ok',
    message: null,
})

const isVisible = ref(false)

emitter.on('toast:ok', onOk)
emitter.on('toast:error', onError)

function onOk (message) {
    showToast('ok', message)
}

function onError (message) {
    showToast('error', message)
}

function showToast (type, message) {
    toast.value.type = type
    toast.value.message = message

    isVisible.value = true

    setTimeout(() => {
        toast.value.message = message
        isVisible.value = false
    }, 3000)
}
</script>

<template>
    <div
        v-if="isVisible"
        class="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 max-w-xs bg-white border border-gray-200 rounded shadow-md"
    >
        <div class="flex items-center p-4">
            <icon :name="toast.type === 'ok' ? 'check' : 'error'" class="shrink-0 size-8 mt-0.5 text-red-500"></icon>
            <div class="ms-3">
                <p class="text-sm text-gray-700" v-html="toast.message"></p>
            </div>
        </div>
    </div>
</template>
